import { useLeftNavConfig } from './useLeftNavConfig.js';

export { useLeftNavConfig } from './useLeftNavConfig.js';
export default useLeftNavConfig;
